import Box from '@mui/material/Box';
import { BracketPanel } from './BracketPanel';
import { useMatchDetails } from '../match/details/MatchDetailsProvider';
import { useMobile } from 'src/hooks/useMobile';
import { useBracket } from './BracketProvider';
import { BracketBoardProps } from './BracketBoard';

export const SPONSORS_HEIGHT = 204;
export const SPONSORS_WIDTH = 500;

export const BracketPanelRendered = ({
  isLoserBracket,
}: Pick<BracketBoardProps, 'isLoserBracket'>) => {
  const { MatchDetails, reset } = useMatchDetails();
  const { sponsors } = useBracket();
  const isMobile = useMobile();

  const containerSx = isMobile
    ? { mx: 4, mt: 4, mb: 8, pb: 8, width: `calc(100% - ${SPONSORS_WIDTH}` }
    : {
        top: isLoserBracket ? 0 : '108px',
        left: `calc(50% - ${SPONSORS_WIDTH} / 2)`,
        position: 'absolute',
      };
  return (
    <Box sx={containerSx}>
      <BracketPanel
        sponsors={sponsors || []}
        MatchDetails={MatchDetails}
        direction="column"
        onClose={reset}
        sx={{
          height: SPONSORS_HEIGHT,
          width: SPONSORS_WIDTH,
          position: 'relative',
          zIndex: 100,
        }}
        TitleProps={{
          variant: 'h6',
        }}
      />
    </Box>
  );
};
